<template>
  <tr v-if="slices">
    <td>
      <b-button
        class="px-0"
        variant="flat"
        :aria-expanded="show ? 'true' : 'false'"
        aria-controls="collapse"
        @click="show = !show"
      >
        <feather-icon
          :icon="show ? 'MinusCircleIcon' : 'PlusCircleIcon'"
          size="18"
        />
      </b-button>
      <span> {{ setSlicingTitle() }} Slicing</span>
      <b-collapse
        id="collapse"
        v-model="show"
      >
        <div
          v-for="(slice, ind) in slices"
          :key="ind"
          class="ml-2"
        >
          <span> {{ slice.from_unit ? ( (slice.from_unit % 1) == 0 ? slice.from_unit : slice.from_unit.toFixed(3)) : 0 }} - {{ slice.to_unit ? ( (slice.to_unit % 1) == 0 ? slice.to_unit : slice.to_unit.toFixed(3)) : '_' }} ( {{ slice.slice_price ? ( (slice.slice_price % 1) == 0 ? slice.slice_price : slice.slice_price.toFixed(3)) : '_' }} ) --> {{ slice.amount ? ( (slice.amount % 1) == 0 ? slice.amount : slice.amount.toFixed(3)) : '_' }}</span>
        </div>
      </b-collapse>
    </td>
  </tr>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BButton, BCollapse,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BCollapse,
  },
  props: {
    slices: {
      type: Array,
      default: () => [],
    },
    slicingType: {
      type: String,
      default: 'time',
    },

  },
  setup(props) {
    const show = ref(false)
    let type = null
    const setSlicingTitle = () => {
      if (props.slicingType === 'time') {
        type = 'Time'
      } else
      if (props.slicingType === 'distance') {
        type = 'Distance'
      } else
      if (props.slicingType === 'journey') {
        type = 'Journey wait time'
      } return type
    }

    return {
      show,
      setSlicingTitle,
    }
  },

}
</script>

<style>

</style>
